import {SearchCriteria} from "./SearchCriteria";

export class QuoteSearchCriteria extends SearchCriteria {
  parkGroupId?: string;
  status?: string;
  internallyApproved?: boolean;
  query?: string;
  plot?: string;
  park?: string;
  leadContractNumber?: string;
  customerId?: number;
  serialNumber?: string;

  onHold?: boolean;
  missingPurchaseOrderNumber?: boolean;
  missingFinalPlan?: boolean;
  hasContractNumber?: boolean;
  onHoldStatusId?: string;

  userId?: string;
  teamData?: boolean;
}
